import { WhatsAppConfigurationFields } from 'src/actions/channels/whatsAppSenderResource';

export class WhatsAppSender {
  id: string;
  phoneNumber: string;
  phoneNumberSID?: string;
  displayName?: string;
  wabaID: string;

  constructor(fields: WhatsAppConfigurationFields) {
    if (fields.isGladlyNumber) {
      this.phoneNumber = fields.gladlyPhoneNumber;
      this.phoneNumberSID = fields.phoneSid;
      this.displayName = fields.displayName;
    } else {
      this.phoneNumber = fields.ownPhoneNumber;
    }
  }

  setWabaID(wabaID: string) {
    this.wabaID = wabaID;
  }
}

export enum SenderStatus {
  ONLINE = 'Online', // connected
  PENDING = 'Pending', // pending registration, alert if more than 24 hrs
}
